<template>
  <TextField
    v-bind="$attrs"
    v-on="$listeners"
    clearable
    prepend-inner-icon="mdi-magnify"
    @input="debounceQuery"
  >
    <template #message="bind">
      <slot name="items" v-bind="{...bind, items, debounce}">
        <span v-if="items === undefined" :key="bind.key">{{ bind.message }}</span>
        <v-progress-linear indeterminate v-else-if="debounce"></v-progress-linear>
        <slot v-else-if="items.length === 0" name="no-items" v-bind="bind">
          <T>По вашему запросу ничего не найдено</T>
        </slot>
        <v-list v-else dense>
          <ScrollerHanlder style="max-height: 40vh">
            <v-list-item v-for="item in items" :key="item.value" @click="$emit('click:item', item)">
              <slot name="item" :item="item">
                <v-list-item-title>{{item.text}}</v-list-item-title>
              </slot>
            </v-list-item>
          </ScrollerHanlder>
        </v-list>
      </slot>
    </template>

  </TextField>
</template>

<script>
import TextField from './TextField.vue'
import ScrollerHanlder from '../scroller_handler'

export default {
  props: ['items'],
  data: () => ({
    debounce: false,
    timeout: undefined
  }),
  watch: {
    items() {
      this.debounce = false
    }
  },
  methods: {
    debounceQuery(condition) {
      this.debounce = true
      
      if (this.timeout !== undefined) {
        clearTimeout(this.timeout)
        this.timeout = undefined
      }

      this.timeout = setTimeout(
        this.runQuery,
        1000,
        condition
      )
    },
    runQuery(condition) {
      this.$emit('runQuery', condition)
    }
  },
  components: {
    TextField,
    ScrollerHanlder
  }
}
</script>